import { useCollection } from 'react-firebase-hooks/firestore';
import { collection } from "firebase/firestore";
import { FirestoreDb } from './firestore';
import {
  doc,
  getDocs,
  getDoc,
  updateDoc,
  setDoc,
  deleteDoc,
} from "firebase/firestore";
import { TENANTS } from './constants/DbNameConstants';

export const GetAllAndSubscribe = (dataType, tenantId) => {
  return useCollection(
    collection(
      FirestoreDb,
      `${TENANTS}/${tenantId}/${dataType}`
    )
  );
}

export const getData = async (domain, id) => {
  const dataRef = doc(FirestoreDb, `${domain}/${id}`);

  return (await getDoc(dataRef)).data();
};

export const addData = async (tenantId, domain, data) => {
  const newdataRef = doc(
    collection(FirestoreDb, `${TENANTS}/${tenantId}/${domain}`)
  );
  await setDoc(newdataRef, { id: newdataRef.id, ...data });
};

export const deleteData = async (tenantId, collectionName, data) => {
  const dataRef = doc(
    FirestoreDb,
    `${TENANTS}/${tenantId}/${collectionName}`,
    data.id
  );
  await deleteDoc(dataRef);
};

export const editData = async (tenantId, domain, data) => {
  const dataRef = doc(
    FirestoreDb,
    `${TENANTS}/${tenantId}/${domain}`,
    data.id
  );
  await updateDoc(dataRef, {
    ...data,
  });
};

//https://www.sitepoint.com/react-firebase-build-mvp/
// returns list of records as an array of javascript objects
export const getAllDataOnce = async (tenantId, collectionName) => {
  console.log("HERE",tenantId)
  const querySnapshot = await getDocs(
    collection(FirestoreDb, `${TENANTS}/${tenantId}/${collectionName}`)
  );
  console.log("querySnapshot",(querySnapshot.docs?.map((doc) => {
    return {
      ...doc.data(),
    }
  })));
  return querySnapshot.docs?.map((doc) => {
    return {
      ...doc.data(),
    };
  });
};

